













































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { SubscriptionLevel } from "@teacherskaya/api-provider/dist/api/SubscriptionLevelProvider";
import { Dictionary, FormValues, ListFields } from "@/types";
import { addDays, differenceInCalendarDays, isAfter } from "@/lib/helpers/time";
import { formatMoney } from "@/lib/helpers/money";
import providers from "@/lib/providers";
import UserAutocomplete from "@/components/UserAutocomplete";
import ModalContainer from "@/components/ModalContainer.vue";
import DateRangePicker from "@/components/DateRangePicker";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import PageTitle from "@/components/PageTitle.vue";
import BlockBase from "@/components/BlockBase.vue";
import { fields } from "./config";

export default defineComponent({
  name: "BlockAddSubscription",
  components: { PageTitle, BlockBase, BlockBaseForm, ModalContainer, UserAutocomplete, DateRangePicker },
  props: {
    providerId: { type: String, required: true },
  },
  setup(props, ctx) {
    const showAddSubscription = ref(false);
    const validForm = ref(false);
    const processing = ref(false);
    const subscriptionLevels = ref<SubscriptionLevel[]>([]);
    const fieldsErrors = ref<Dictionary<string[]>>({});
    const fieldsNew = computed(() => {
      const list = subscriptionLevels.value.reduce<ListFields>((out, level) => {
        if (level.pricePackage) {
          out.push({
            text: `${level.pricePackage.name}, ${formatMoney(level.pricePackage.amount)}`,
            value: level.id,
          });
        }
        return out;
      }, []);
      return fields.map(field => {
        if (field.name === "subscriptionLevel") {
          return {
            ...field,
            list,
          };
        }
        return field;
      });
    });

    watch(showAddSubscription, async newVal => {
      if (newVal) {
        subscriptionLevels.value = await providers.SubscriptionLevelProvider.find({ userIds: [props.providerId] });
      }
    });
    const save = async ({ user, subscriptionLevel, expirationDate }: FormValues, BlockBaseFormInstance: any) => {
      if (
        !validForm.value ||
        !user ||
        !subscriptionLevel ||
        !expirationDate.dateEnd ||
        isAfter(new Date(), new Date(expirationDate.dateEnd))
      ) {
        return;
      }
      try {
        processing.value = true;
        const daysDifference = differenceInCalendarDays(new Date(expirationDate.dateEnd), new Date());
        const expirationTime = addDays(new Date(), daysDifference).toISOString();
        const data = {
          consumerId: user.id,
          expirationTime,
          levelId: subscriptionLevel,
        };
        const addedSubscription = await providers.SubscriptionProvider.create({ data });
        ctx.emit("addedSubscription", addedSubscription);
      } finally {
        processing.value = false;
        showAddSubscription.value = false;
        BlockBaseFormInstance.clearAll();
      }
    };
    const cancel = () => {
      showAddSubscription.value = false;
    };

    return {
      showAddSubscription,
      fieldsNew,
      fieldsErrors,
      validForm,
      processing,
      save,
      cancel,
    };
  },
});
